module.exports = __webpack_public_path__ + "static/media/iconSucces.31ec2353.svg";